import * as yup from "yup";

export const campaignValidationSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .min(3, "Campaign name must be at least 3 characters")
    .max(30, "Campaign name must be at most 30 characters")
    .required("Campaign name is required"),
  place: yup
    .string()
    .trim()
    .min(3, "Campaign place must be at least 3 characters")
    .max(100, "Campaign place must be at most 100 characters")
    .required("Campaign place is required"),
  date: yup
    .date()
    .typeError("Campaign date must be a valid date")
    .required("Campaign date is required"),
  orderNumberSequencePrefix: yup
    .string()
    .trim()
    .max(10, "Order number sequence prefix must be at most 10 characters")
    .required("Order number sequence prefix is required"),
});
